import { render, staticRenderFns } from "./IconRdvTel.vue?vue&type=template&id=8849812c&"
import script from "./IconRdvTel.vue?vue&type=script&lang=js&"
export * from "./IconRdvTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports